<template>
    <v-card color="primary" flat tile max-width="100%" height="100%">
        <v-card-text>
            <v-list class="mt-12">
                <v-list-item-group>
                  <template v-for="(item, i) in menu">
                    <v-list-item :key="i"
                                 v-if="item.show"
                                 @click="$routerService.goTo(item.route)">
                      <v-list-item-icon class="mr-4">
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content v-text="$t(item.content)"></v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list-item-group>
            </v-list>
            <locales-component/>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "SidenavComponent",
        data() {
            return {
                items: [
                    {
                        icon: 'mdi-email-edit-outline',
                        content: 'developers.contact',
                        route: 'contact',
                        show: true
                    },
                ]
            }
        },
        computed: {
            menu() {
                return this.items;
            }
        }
    }
</script>

<style scoped>

</style>
